import React from 'react'

const SecondaryButton = ({processing, buttonAction, buttonLabel}) => {
  return (
    <button type='submit' disabled={processing} onClick={()=>{buttonAction()}} className='w-full p-4 rounded-[8px] bg-doiteasy-light-gray text-gray-600 text-sm font-[550] transition duration-200 hover:bg-gray-100 hover:text-vcm-purple flex items-center justify-center'>{processing ? <div className='btn-loader' /> : buttonLabel}</button>
  )
}

export default SecondaryButton